import { observer } from 'mobx-react-lite'
import { Icon, type IDropdownItem, Tooltip, Typography } from 'shared/ui'
import { LiveDocumentAccessLostIndicator } from 'pages/chatbot/ui/LiveDocumentAccessLostIndicator/LiveDocumentAccessLostIndicator'
import styles from './styles.module.scss'

const getIsAccessLostDropdownItem = (item: IDropdownItem): boolean =>
  item.customFields?.isAccessLost === true

export const DocumentsSelectTrigger = observer(
  ({
    selectedDocuments,
    isSelectAllDocuments,
    isError,
  }: {
    selectedDocuments: IDropdownItem[]
    isSelectAllDocuments: boolean
    isError?: boolean
  }) => {
    const visibleItems = selectedDocuments.slice(0, 6)
    const tooltipItems = selectedDocuments.slice(6)
    const hasHiddenAccessLost = tooltipItems.some(getIsAccessLostDropdownItem)

    if (!selectedDocuments.length) {
      return (
        <div className={styles.emptyWrap}>
          <Typography
            color={'var(--content-primary-disabled)'}
            variant={'body-md-regular'}
            ariaLabel={'placeholder'}
          >
            Select documents
          </Typography>
        </div>
      )
    }

    if (isSelectAllDocuments) {
      return (
        <div className={styles.emptyWrap}>
          <Typography variant={'text-input-field-r'} ariaLabel={'allSelected'}>
            All documents selected
          </Typography>
        </div>
      )
    }

    return (
      <div className={styles.trigger}>
        {visibleItems.map((item) => {
          const isAccessLost = getIsAccessLostDropdownItem(item)
          return (
            <div className={styles.triggerContentWrap} key={item.id}>
              {item.iconL && <Icon icon={item.iconL} color={'var(--content-primary-tertiary)'} />}
              <div className={styles.info}>
                <Typography
                  ariaLabel={'documentName'}
                  color={'var(--content-primary-primary)'}
                  variant={'body-md-regular'}
                  ellipsis
                >
                  {item.label}
                </Typography>
              </div>
              {isAccessLost && <LiveDocumentAccessLostIndicator isError={isError} />}
            </div>
          )
        })}
        {!!tooltipItems.length && (
          <div className={styles.remainderWrap}>
            <Tooltip
              label={
                <div className={styles.tooltipItems}>
                  {tooltipItems.map((item) => (
                    <div key={item.id}>{item.label}</div>
                  ))}
                </div>
              }
              placement='top'
            >
              <div className={styles.remainderCount}>+{tooltipItems.length}</div>
            </Tooltip>
            {hasHiddenAccessLost && <LiveDocumentAccessLostIndicator isError={isError} />}
          </div>
        )}
      </div>
    )
  }
)
